import { useEffect } from 'react';
import { UpdateValidationState } from './useValidationState';

const useAmountValidationStateUpdate = (
  vendorCurrency: string,
  formAmount: string,
  isAmountValid: boolean,
  updateValidationState: UpdateValidationState
): void => {
  useEffect(() => {
    updateValidationState({ field: 'amount', isValid: isAmountValid });
  }, [vendorCurrency, formAmount, isAmountValid]);
};

export default useAmountValidationStateUpdate;
